var Codec = require('io/codec');
var ErrorReportSerialiser = require('../error-report-serialiser');

var FilterSendResult = require('./filter-send-result');

var serialiser = {
    read : function(input) {
        var sent = Codec.readInt32(input);
        var errors = Codec.readCollection(input, ErrorReportSerialiser.read);
        return new FilterSendResult(sent, errors);
    },
    write : function(output, req) {
        Codec.writeInt32(output, req.sent);
        Codec.writeCollection(output, req.errors, ErrorReportSerialiser.write);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/send/filter-send-result-serialiser.js
// module id = 1697
// module chunks = 1